var _defs, _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfcSiteContainedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009ad9;\n      }\n\n      .cls-2 {\n        fill: #363545;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.45 16.86 6.57 16.86 7.66 14.45 5.55 14.45 4.45 16.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.74 11.67 15.28 11.67 15.28 9.75 12.23 9.75 11.74 11.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.72 9.75 16.72 11.67 20.26 11.67 19.77 9.75 16.72 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.28 22.25 15.28 20.33 9.51 20.33 9.01 22.25 15.28 22.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.75 11.67 23.08 11.67 23.68 13.01 25.8 13.01 24.32 9.75 21.26 9.75 21.75 11.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.02 20.33 4.99 20.33 5.91 18.3 3.8 18.3 2 22.25 7.52 22.25 8.02 20.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.09 18.3 27.01 20.33 23.98 20.33 24.48 22.25 30 22.25 28.2 18.3 26.09 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.49 20.33 16.72 20.33 16.72 22.25 22.99 22.25 22.49 20.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.32 13.01 8.92 11.67 10.25 11.67 10.74 9.75 7.68 9.75 6.2 13.01 8.32 13.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.45 14.45 24.34 14.45 25.43 16.86 27.55 16.86 26.45 14.45"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32 32 26 32 26 30 30 30 30 26 32 26 32 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6 32 0 32 0 26 2 26 2 30 6 30 6 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2 6 0 6 0 0 6 0 6 2 2 2 2 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32 6 30 6 30 2 26 2 26 0 32 0 32 6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.31,16.26c2.11-.34,5.85-1.39,7.54-4.74l-.89-.45c-1.92,3.81-7.15,4.29-8.04,4.34-.04-.02-.07-.04-.1-.06-3.8-2.36-7.99-.82-8.17-.75l.35.94s3.92-1.43,7.29.67c2.11,1.31,3.79,2.36,6.12,2.36,1.6,0,3.5-.5,6.06-1.74l-.44-.9c-4.9,2.39-7.03,1.88-9.7.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfcSiteContainedSvg);
export default __webpack_public_path__ + "static/media/IFCSiteContained_svg.09b059cf90db53db7dbf3fe37f498c15.svg";
export { ForwardRef as ReactComponent };